import { render, staticRenderFns } from "./Lottie.vue?vue&type=template&id=4bce584c&scoped=true"
import script from "./Lottie.vue?vue&type=script&lang=js"
export * from "./Lottie.vue?vue&type=script&lang=js"
import style0 from "./Lottie.vue?vue&type=style&index=0&id=4bce584c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bce584c",
  null
  
)

export default component.exports